import { render, staticRenderFns } from "./DiscountCodeForm.vue?vue&type=template&id=38fdba37&scoped=true&"
import script from "./DiscountCodeForm.vue?vue&type=script&lang=ts&"
export * from "./DiscountCodeForm.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountCodeForm.vue?vue&type=style&index=0&id=38fdba37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fdba37",
  null
  
)

export default component.exports